import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af } from '../theme';

const styles = {
  /**
   * Generous vertical padding rather than a stretched box: the loader replaces a whole
   * screen, and centring it in the card's natural height would make the card jump between
   * the wait and the content.
   */
  root: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${af.sp12} 0;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
